import React, { useState } from 'react';
import { AppDialog, AppDialogClose } from '../../../components/common/CustomMdal';
import { MdOutlineLocalPhone, MdOutlineMail, MdLocationOn } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import './SupportSection.scss';

const SupportSection: React.FC = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <>
      <section className="logged-home-support">
        <div className="logged-home-support-inner">
          <div className="logged-home-support-icon-wrap">
            <MdOutlineLocalPhone size={64} className="logged-home-support-icon" aria-hidden />
          </div>
          <div className="logged-home-support-content">
            <h2 className="logged-home-support-title">We&apos;re Here To Help</h2>
            <p className="logged-home-support-desc">
              Need Help organizing a league or tournament ? Our team can guide you every step of the way.
            </p>
          </div>
          <div className="logged-home-support-btns">
            <button
              type="button"
              className="logged-home-support-btn logged-home-support-btn--primary"
              onClick={() => setIsContactModalOpen(true)}
            >
              <MdOutlineLocalPhone size={28} aria-hidden />
              Contact Us
            </button>
            {/* <button
              type="button"
              className="logged-home-support-btn logged-home-support-btn--secondary"
              onClick={() => setIsContactModalOpen(true)}
            >
              <MdOutlineMail size={28} aria-hidden />
              Contact Support
            </button> */}
          </div>
        </div>
      </section>

      <AppDialog
        open={isContactModalOpen}
        onOpenChange={setIsContactModalOpen}
        title="Contact Information"
        size="sm"
        showCloseIcon={false}
        className="logged-home-support-dialog"
      >
        <div className="logged-home-support-dialog-body">
          <AppDialogClose className="logged-home-support-dialog-close" aria-label="Close">
            <IoClose size={18} />
          </AppDialogClose>

          <div className="logged-home-support-contact-list">
            <div className="logged-home-support-contact-item">
              <MdOutlineLocalPhone size={18} aria-hidden />
              <span>+2782 283782</span>
            </div>
            <div className="logged-home-support-contact-item">
              <MdOutlineMail size={18} aria-hidden />
              <span>support@cc.com</span>
            </div>
            <div className="logged-home-support-contact-item logged-home-support-contact-item--location">
              <MdLocationOn size={18} aria-hidden />
              <span>132 Dartmouth Street Boston, Massachusetts 02156 United States</span>
            </div>
          </div>
        </div>
      </AppDialog>
    </>
  );
};

export default SupportSection;
